// extracted by mini-css-extract-plugin
module.exports = {"sectionNavigation":"SectionNavigation_sectionNavigation__7Al_u"};